// extracted by mini-css-extract-plugin
export default {"marginTop16":"RosterConfigInputs_marginTop16__Szl3V","colorRed":"RosterConfigInputs_colorRed__TBkCB"};